export const classes = {
  listItemButton:
    'transition-colors duration-100 py-[11px] px-4 my-0.5 mx-2 rounded-[15px]',
};

export const styles = {
  listItemButton: {
    '&': { width: 'unset' },
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: 'rgba(127,127,127,0.14)',
    },
    '& .MuiTypography-body1': {
      fontSize: '1.125rem',
      lineHeight: '1.75rem',
    },
    '& .MuiTypography-body2': {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
    },
  },
};
